import { Component, OnInit } from '@angular/core';
import { IOption } from 'ng-select';

@Component({
  selector: 'app-loop',
  templateUrl: './loop.component.html',
  styleUrls: ['./loop.component.scss']
})
export class LoopComponent implements OnInit {
loading:boolean=true;
serialnumber:any;
SerialNumberDropdown:Array<IOption>=[];
  constructor() { }

  ngOnInit() {
    this.loading=false;
  }
  InputSerialNumber(value){
    
  }

  
}



// WEBPACK FOOTER //
// ./client/app/loop/loop.component.ts